// extracted by mini-css-extract-plugin
export default {"action":"xb4Oz9","info":"pCfhgX","icon":"vBESjQ"};